export default function exportData(data, type='text/plain', fileName='export.txt') {
  const blob  = new Blob([data], { type });
  const url   = window.URL.createObjectURL(blob);
  const a     = document.createElement('a');

  a.setAttribute('href', url);
  a.setAttribute('download', fileName);
  a.click();
}